import { useExternalConfig } from '@store/contexts/ExternalConfig';
import { useReCaptcha as uiUseRecaptcha } from '@yoweb/ui/hooks/useReCaptcha';

/**
 * Adds the ReCaptcha script to the page allows executing ReCaptcha actions.
 */
function useReCaptcha() {
  var _useExternalConfig = useExternalConfig(),
      recaptcha = _useExternalConfig.recaptcha;

  return uiUseRecaptcha(recaptcha.publicKey);
}

export default useReCaptcha;